"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashCode = void 0;
/**
 * @see http://stackoverflow.com/q/7616461/940217
 */
function hashCode(str) {
    var hash = 0;
    if (str.length === 0)
        return hash;
    // tslint:disable-next-line:no-increment-decrement
    for (var i = 0; i < str.length; i++) {
        var character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
exports.hashCode = hashCode;
